export var Copyright={VERSION:"2022.0"};